import { IconContext } from "react-icons";
import "../../styles/PageStyle/Contact.css";
import { GiModernCity } from "react-icons/gi";
import Divider from "../../components/ToolComp/divider";
function Contact() {
  return (
    <div id="contactus" className="contact main-section">
      <div className="content-container">
        <h1>Contact Us</h1>
        <Divider />
        <div className="contact-container">
          <div className="col1 griditem">
            <div className="icon-outter">
              <div className="circle">
                <div className="circle-inner">
                  <IconContext.Provider
                    value={{ color: "rgb(184, 134, 11)", size: "6rem" }}
                  >
                    <GiModernCity />
                  </IconContext.Provider>
                </div>
              </div>
            </div>
            <p className="office">Toronto Office</p>
            <div className="content-wrap">
              <p className="email">
                <span
                  style={{ color: "rgb(184, 134, 11)", fontWeight: "bold" }}
                >
                  Email:
                </span>
                <a href="mailto:admissions@evaschool.ca" className="email-link">
                  admissions@evaschool.ca
                </a>
              </p>
              <p className="address">
                <span
                  style={{ color: "rgb(184, 134, 11)", fontWeight: "bold" }}
                >
                  Address:{" "}
                </span>
                170 Sheppard Ave E, North York, Ontario, Canada M2N 3A4
              </p>
              <p className="fax">
                <span
                  style={{ color: "rgb(184, 134, 11)", fontWeight: "bold" }}
                >
                  Fax/Phone:{" "}
                </span>
                +1(437)268-6158
              </p>
            </div>
          </div>
          <div className="col2 griditem">
            <div className="content-wrap">
              <p className="qr-section">
                <img src="/img/qrcode.png" alt="QR Code" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
